import { useState, useEffect } from "react";
import { NotificationList } from "../components/NotificationList";
import { Button } from "../components/base";
import { PageLayout } from "../components/PageLayout";
import { useAppDispatch, useAppSelector } from "../redux";
import { setFilters, markAllAsRead } from "../redux/reducers/notificationSlice";

export const NotificationsPage = () => {
  const dispatch = useAppDispatch();
  const { unreadCount } = useAppSelector((state) => state.notifications);
  const [activeTab, setActiveTab] = useState<string>("all");

  const handleMarkAllRead = () => {
    dispatch(markAllAsRead());
  };

  const tabs = [
    { id: "all", label: "All" },
    { id: "unread", label: "Unread" },
    { id: "test", label: "Test" },
    // The below are not yet active categories, so they are commented out for now.
    // See active categories in CATEGORIES in NotificationPreferencesPage.tsx and uncomment the below as more categories become functional.
    // { id: "billing", label: "Billing" },
    // { id: "function", label: "Function" },
    // { id: "account", label: "Account" },
    // { id: "system", label: "System" },
    // { id: "agent", label: "Agent" },
    // { id: "community", label: "Community" },
  ];

  const getCategoryFromTab = (tabId: string): string | undefined => {
    if (tabId === "all" || tabId === "unread") {
      return undefined;
    }
    return tabId;
  };

  // Update Redux filter when tab changes
  useEffect(() => {
    if (activeTab === "unread") {
      dispatch(setFilters({ unread: true }));
    } else {
      dispatch(setFilters({ unread: undefined }));
    }
  }, [activeTab, dispatch]);

  return (
    <PageLayout
      title="Notifications"
      description=""
      tabs={tabs}
      activeTab={activeTab}
      onTabChange={setActiveTab}
      tabAction={
        unreadCount > 0 ? (
          <Button
            type="button"
            variant="ghost"
            size="sm"
            onClick={handleMarkAllRead}
          >
            Mark all read
          </Button>
        ) : undefined
      }
    >
      <NotificationList
        category={getCategoryFromTab(activeTab)}
        showFilters={false}
      />
    </PageLayout>
  );
};
